module.exports = __webpack_public_path__ + "media/hdVideo.4cd87309.mp4";